import {
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import {
    chain,
    LoadRealTimeInventory,
    LoadRealTimePrices,
} from "@insite/client-framework/Store/Components/ProductInfoList/Handlers/LoadProductInfoList";
replaceInChain(
    chain,
    LoadRealTimePrices,
    props => {
        
    },
);

replaceInChain(
    chain,
    LoadRealTimeInventory,
    props => {

    },
);
